// import api from '@/apis'

export default {
  state: {
    visibility: false,
    script: ''
  },
  mutations: {
    INIT_PREVIEW_SCRIPT_DIALOG(state, payload) {
      state.visibility = true
      state.script = payload
    },
    RESET_PREVIEW_SCRIPT_DIALOG(state) {
      state.visibility = false
      state.script = null
    }
  }
}
